import { render, staticRenderFns } from "./resumptionStatistic.vue?vue&type=template&id=1b4d1979&scoped=true&"
import script from "./resumptionStatistic.vue?vue&type=script&lang=js&"
export * from "./resumptionStatistic.vue?vue&type=script&lang=js&"
import style0 from "./resumptionStatistic.vue?vue&type=style&index=0&id=1b4d1979&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d1979",
  null
  
)

export default component.exports